/**
 * Gemini API Client for Google Workspace Gemini analytics
 * Uses the unified API client. Nginx routes /gemini/api/v1/* to the
 * saf3ai-gemini-microservice.
 */

import api from './apiClient';

const PREFIX = '/gemini/api/v1';

/**
 * Gemini API methods
 */
export const geminiAPI = {
  // Dashboard
  getDashboard: async (params = {}) => {
    const response = await api.get(`${PREFIX}/dashboard`, { params });
    return response.data;
  },

  getDashboardStats: async (params = {}) => {
    const response = await api.get(`${PREFIX}/dashboard`, { params });
    return response.data;
  },

  getActivityFeed: async (params = {}) => {
    const response = await api.get(`${PREFIX}/dashboard/activity-feed`, { params });
    return response.data;
  },

  // Users
  getUsers: async (params = {}) => {
    const response = await api.get(`${PREFIX}/users`, { params });
    return response.data;
  },

  getUserSummary: async (userEmail, params = {}) => {
    const response = await api.get(`${PREFIX}/users/${encodeURIComponent(userEmail)}/summary`, { params });
    return response.data;
  },

  // Applications
  getApplications: async (params = {}) => {
    const response = await api.get(`${PREFIX}/applications`, { params });
    return response.data;
  },

  // Sessions
  getSessions: async (params = {}) => {
    const response = await api.get(`${PREFIX}/sessions`, { params });
    return response.data;
  },

  getSessionDetails: async (sessionId) => {
    const response = await api.get(`${PREFIX}/sessions/${encodeURIComponent(sessionId)}`);
    return response.data;
  },

  getSessionFilters: async (params = {}) => {
    const response = await api.get(`${PREFIX}/sessions/filters`, { params });
    return response.data;
  },

  // Threats
  getThreats: async (params = {}) => {
    const response = await api.get(`${PREFIX}/threats`, { params });
    return response.data;
  },

  getThreatsSummary: async (params = {}) => {
    const response = await api.get(`${PREFIX}/threats/summary`, { params });
    return response.data;
  },

  // Interactions
  getInteractions: async (params = {}) => {
    const response = await api.get(`${PREFIX}/interactions`, { params });
    return response.data;
  },

  // Intent Analysis
  getIntentAnalysis: async (params = {}) => {
    const response = await api.get(`${PREFIX}/intent-analysis`, { params });
    return response.data;
  },

  // Knowledge Gaps
  getKnowledgeGaps: async (params = {}) => {
    const response = await api.get(`${PREFIX}/knowledge-gaps`, { params });
    return response.data;
  },

  // Compliance
  getCompliance: async (params = {}) => {
    const response = await api.get(`${PREFIX}/compliance`, { params });
    return response.data;
  },

  getComplianceFrameworks: async (params = {}) => {
    const response = await api.get(`${PREFIX}/compliance/frameworks`, { params });
    return response.data;
  },

  // Audit Log
  getAuditLog: async (params = {}) => {
    const response = await api.get(`${PREFIX}/audit-log`, { params });
    return response.data;
  },

  // Alias for audit logs (used by some components)
  getAuditLogs: async (params = {}) => {
    const response = await api.get(`${PREFIX}/audit-log`, { params });
    return response.data;
  },

  // Configuration
  getConfig: async (orgId = 1) => {
    const response = await api.get(`${PREFIX}/config`, { params: { organization_id: orgId } });
    return response.data;
  },

  updateConfig: async (configOrOrgId, configData) => {
    // Normalize: supports (config) and (orgId, config) call signatures.
    // Backend reads org_id from JWT — organization_id query param is not needed.
    const body = configData !== undefined ? configData : configOrOrgId;
    const response = await api.put(`${PREFIX}/config`, body);
    return response.data;
  },

  resetConfig: async (orgId = 1) => {
    const response = await api.post(`${PREFIX}/config/reset`, null, { params: { organization_id: orgId } });
    return response.data;
  },

  // Health
  getHealth: async () => {
    const response = await api.get(`${PREFIX}/health`);
    return response.data;
  },

  getHealthDetailed: async () => {
    const response = await api.get(`${PREFIX}/health/detailed`);
    return response.data;
  },
};

export default geminiAPI;
